"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _reactDatePicker = _interopRequireDefault(require("react-date-picker"));
var _reactHookForm = require("react-hook-form");
var _dateMap = _interopRequireDefault(require("./dateMap"));
const CUR_DATE = new Date();
const MIN_DATE = new Date((CUR_DATE.getFullYear() - 118).toString());
const BirthdayInput = (0, _styled.default)(_reactDatePicker.default)(_ref => {
  let {
    theme,
    fieldIsDirty,
    isFocused
  } = _ref;
  return {
    background: 'transparent',
    border: '0',
    color: theme === null || theme === void 0 ? void 0 : theme.colors.inputText,
    flex: '1',
    fontSize: theme === null || theme === void 0 ? void 0 : theme.fontSizes.small,
    fontWeight: theme === null || theme === void 0 ? void 0 : theme.fontWeights.regular,
    lineHeight: '1',
    marginBottom: '5px',
    outline: '0',
    paddingTop: '0px',
    paddingLeft: '16px',
    paddingRight: '16px',
    position: 'relative',
    'input::placeholder': {
      color: theme === null || theme === void 0 ? void 0 : theme.colors.textPrimary,
      fontWeight: theme === null || theme === void 0 ? void 0 : theme.fontWeights.regular
    },
    '.react-date-picker__inputGroup': {
      paddingTop: '25px',
      marginLeft: '-2px'
    },
    '.react-date-picker__inputGroup__divider': {
      opacity: isFocused || fieldIsDirty ? 1 : 0
    },
    '.react-date-picker__inputGroup__input': {
      color: theme === null || theme === void 0 ? void 0 : theme.colors.inputText
    },
    '.react-date-picker__inputGroup__input:focus': {
      backgroundColor: 'rgba(128, 188, 254, 0.3)',
      outline: 'none'
    },
    '.react-date-picker__inputGroup__input:not(:focus)': {
      backgroundColor: 'transparent !important'
    },
    '.react-date-picker__inputGroup__input::placeholder,': {
      opacity: isFocused || fieldIsDirty ? 1 : 0
    },
    '.react-date-picker__wrapper': {
      border: 'none'
    },
    ':focus-visible': {
      outline: 'none'
    }
  };
});

/**
 * A component used to gather a user's birthday with minimal validation.
 * Displays a localized version of the date and its value is in the format of yyyy-mm-dd for form submission.
 */
const Birthday = _ref2 => {
  var _ref3, _dateMap$placeholder$, _dateMap$placeholder, _placeholder$match, _dateMap$placeholder$2, _dateMap$placeholder2, _dateMap$placeholder$3, _dateMap$placeholder3, _dateMap$placeholder$4, _dateMap$placeholder4;
  let {
    control,
    disabled = false,
    fieldIsDirty,
    initialValue = '',
    isFocused,
    onBlur,
    onFocus,
    placeholder,
    ref
  } = _ref2;
  const splitCharacter = (_ref3 = (_dateMap$placeholder$ = (_dateMap$placeholder = _dateMap.default[placeholder]) === null || _dateMap$placeholder === void 0 ? void 0 : _dateMap$placeholder.splitCharacter) !== null && _dateMap$placeholder$ !== void 0 ? _dateMap$placeholder$ : (_placeholder$match = placeholder.match(/[^A-Za-z0-9]/g)) === null || _placeholder$match === void 0 ? void 0 : _placeholder$match[0]) !== null && _ref3 !== void 0 ? _ref3 : '/';
  const order = placeholder.split(splitCharacter);
  const dayString = (_dateMap$placeholder$2 = (_dateMap$placeholder2 = _dateMap.default[placeholder]) === null || _dateMap$placeholder2 === void 0 ? void 0 : _dateMap$placeholder2.day) !== null && _dateMap$placeholder$2 !== void 0 ? _dateMap$placeholder$2 : 'DD';
  const monthString = (_dateMap$placeholder$3 = (_dateMap$placeholder3 = _dateMap.default[placeholder]) === null || _dateMap$placeholder3 === void 0 ? void 0 : _dateMap$placeholder3.month) !== null && _dateMap$placeholder$3 !== void 0 ? _dateMap$placeholder$3 : 'MM';
  const yearString = (_dateMap$placeholder$4 = (_dateMap$placeholder4 = _dateMap.default[placeholder]) === null || _dateMap$placeholder4 === void 0 ? void 0 : _dateMap$placeholder4.year) !== null && _dateMap$placeholder$4 !== void 0 ? _dateMap$placeholder$4 : 'YYYY';
  const [initValYear, initValMonth, initValDay] = initialValue ? initialValue.split('-') : ['', '', ''];
  const formatDateString = order.map(ddMMorYYYY => {
    if (ddMMorYYYY === dayString) {
      return 'dd';
    }
    if (ddMMorYYYY === monthString) {
      return 'MM';
    }
    return 'yyyy';
  }).join('/');
  const {
    field: {
      onChange,
      ...inputProps
    }
  } = (0, _reactHookForm.useController)({
    name: 'birthday',
    control,
    defaultValue: initialValue === '' ? '' : new Date(Number(initValYear), Number(initValMonth) - 1, Number(initValDay))
  });

  // Limit the amount of characters allowed in an input:
  const enforceInputMaxLength = e => {
    const target = e.target;
    const {
      id: inputId,
      value
    } = target;
    const maxLengths = {
      'dob_year': 4,
      'dob_month': 2,
      'dob_day': 2
    };
    const propLength = maxLengths[inputId];

    // Restrict length of property:
    if (value.toString().length > propLength) {
      target.value = value.slice(0, propLength);
    }
  };

  // Only allow input to receive numeric characters:
  const enforceInputNumeric = e => {
    const char = e.key.charCodeAt(0);
    // numeric characters | delete key | tab key
    if ((char < 48 || char > 57) && char !== 66 && char !== 84) {
      e.preventDefault();
    }
  };

  // Handle clearing the birthday on locale change. Don't want things to break when things are a different format.
  (0, _react.useEffect)(() => {
    onChange('');
  }, [placeholder]); // eslint-disable-line react-hooks/exhaustive-deps

  // Handle setting the initial value
  (0, _react.useEffect)(() => {
    if (initialValue) {
      onChange(initialValue === '' ? '' : new Date(Number(initValYear), Number(initValMonth) - 1, Number(initValDay)));
    }
  }, [initialValue]); // eslint-disable-line react-hooks/exhaustive-deps

  (0, _react.useEffect)(() => {
    // Add IDs to input fields
    const dayElement = document.getElementsByClassName('react-date-picker__inputGroup__day')[0];
    const monthElement = document.getElementsByClassName('react-date-picker__inputGroup__month')[0];
    const yearElement = document.getElementsByClassName('react-date-picker__inputGroup__year')[0];
    dayElement.id = 'dob_day';
    monthElement.id = 'dob_month';
    yearElement.id = 'dob_year';

    // Add oninput listener to input fields to handle missing Firefox HTML 5 support:
    dayElement.oninput = e => enforceInputMaxLength(e);
    monthElement.oninput = e => enforceInputMaxLength(e);
    yearElement.oninput = e => enforceInputMaxLength(e);

    // Add onkeydown to restrict using non-numeric characters:
    dayElement.onkeydown = e => enforceInputNumeric(e);
    monthElement.onkeydown = e => enforceInputNumeric(e);
    yearElement.onkeydown = e => enforceInputNumeric(e);
  }, []);
  return /*#__PURE__*/_react.default.createElement(BirthdayInput, Object.assign({}, inputProps, {
    disableCalendar: true,
    clearIcon: null,
    dayAriaLabel: "Day",
    dayPlaceholder: dayString,
    disabled: disabled,
    fieldIsDirty: fieldIsDirty,
    format: formatDateString,
    isFocused: isFocused,
    maxDate: CUR_DATE,
    minDate: MIN_DATE,
    monthAriaLabel: "Month",
    monthPlaceholder: monthString,
    nativeInputAriaLabel: "Date"
    // @ts-ignore
    ,
    ref: ref,
    yearAriaLabel: "Year",
    yearPlaceholder: yearString
    // eslint-disable-next-line react/jsx-sort-props
    // @ts-ignore
    ,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus
  }));
};
Birthday.displayName = 'Birthday';
var _default = exports.default = Birthday;